/**
 * ScienceResultsSlide - Gallery slide showing clinical study results
 * Dark blue background with large stat numbers in a 2x2 grid.
 * High CRO layout - numbers are BIG, text is simplified and clear.
 */

export function ScienceResultsSlide() {
  const stats = [
    { number: '90%', label: 'Thicker Hair', text: 'Visible density improvement' },
    { number: '86%', label: 'Less Hair Loss', text: 'Reduced shedding in weeks' },
    { number: '82%', label: 'Healthier Scalp', text: 'Hydrated and revitalized' },
    { number: '82%', label: 'More Confident', text: 'By week 4 of treatment' },
  ];

  return (
    <div className="w-full h-full relative bg-[#0a1628] overflow-hidden flex flex-col items-center justify-center px-4 py-6 lg:px-8 lg:py-8">
      {/* Subtle radial glow */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(0,102,204,0.12)_0%,_transparent_70%)]" />
      
      {/* Header */}
      <div className="relative z-10 text-center mb-5 lg:mb-7">
        <p className="text-[10px] lg:text-xs uppercase tracking-[0.2em] text-[#4d9fff] font-semibold mb-1.5">Dermatologist-Tested Results</p>
        <h3 className="text-lg lg:text-2xl font-bold text-white leading-tight">Proven by Science</h3>
      </div>

      {/* 2x2 Stats Grid */}
      <div className="relative z-10 grid grid-cols-2 gap-3 lg:gap-5 w-full max-w-[440px]">
        {stats.map((stat, idx) => (
          <div 
            key={idx}
            className="text-center bg-white/[0.05] border border-white/[0.1] rounded-xl px-3 py-4 lg:px-5 lg:py-6 backdrop-blur-sm"
            style={{ animation: `fadeSlideIn 0.4s ease-out ${0.1 + idx * 0.1}s both` }}
          >
            <div className="text-3xl lg:text-5xl font-black text-white leading-none mb-1 lg:mb-2 font-heading" style={{ fontVariantNumeric: 'tabular-nums' }}>
              {stat.number}
            </div>
            <p className="text-[11px] lg:text-sm font-semibold text-[#4d9fff] mb-0.5">{stat.label}</p>
            <p className="text-[9px] lg:text-xs text-gray-400 leading-snug">{stat.text}</p>
          </div>
        ))}
      </div>

      {/* Footer disclaimer */}
      <div className="relative z-10 mt-4 lg:mt-6 text-center max-w-[380px]">
        <p className="text-[8px] lg:text-[10px] text-gray-500 leading-relaxed">
          *Dermatologically tested. Micro-Infuse&reg; validated by experts for visible, safe, and lasting results.
        </p>
      </div>
    </div>
  );
}

/**
 * ScienceResultsThumbnail - Compact thumbnail for the gallery strip
 */
export function ScienceResultsThumbnail() {
  return (
    <div className="w-full h-full bg-[#0a1628] flex flex-col items-center justify-center relative overflow-hidden p-1.5">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(0,102,204,0.15)_0%,_transparent_70%)]" />
      <div className="relative z-10 flex flex-col items-center">
        <span className="text-[14px] font-black text-white font-heading leading-none">90%</span>
        <span className="text-[5px] text-[#4d9fff] font-bold uppercase tracking-wider mt-0.5">Thicker Hair</span>
      </div>
    </div>
  );
}

export default ScienceResultsSlide;
